module.exports = __webpack_public_path__ + "img/apply_no_pass.adfaa129.png";